import { network } from 'services/network';

export const getProgressPreferences = (projectId) => {
    return network.post('api/bo/getProgressPreferences', { projectId }).then((response) => {
        return response.data;
    });
};
